export default {
    /**
     * Không dùng phần mềm
     */
    NotUse: 0,
    /**
     * Dùng phần mềm
     */
    Use: 1
}